import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shengchanguanli",
  "use": "icon-shengchanguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shengchanguanli\"><path fill=\"\" d=\"M270.304 483.392L512 604.224l241.696-120.832a32 32 0 1 1 28.608 57.216l-256 128a32 32 0 0 1-28.608 0l-256-128a32 32 0 0 1 28.608-57.216z m0 128L512 732.224l241.696-120.832a32 32 0 0 1 28.608 57.216l-256 128a32 32 0 0 1-28.608 0l-256-128a32 32 0 0 1 28.608-57.216zM327.584 384L512 476.224 696.448 384 512 291.776 327.552 384z m198.72-156.608l256 128a32 32 0 0 1 0 57.216l-256 128a32 32 0 0 1-28.608 0l-256-128a32 32 0 0 1 0-57.216l256-128a32 32 0 0 1 28.608 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shengchanguanli.svg
// module id = kxFc
// module chunks = 67